<template>
<!-- eslint-disable  -->
<div id='admin-sidebar' ref="admin-sidebar" class="sidebar sidebar-open">
  <nav class="sidebar-nav">
    <ul class="nav">
      <li class="nav-item">
        <router-link :to="{ name: 'admin/dashboard' }" class="nav-link"><i class="mr-2 fas fa-tachometer-alt"></i><span>Dashboard</span></router-link>
      </li>
      <li :class="{ 'nav-item nav-dropdown': true, 'open': is_showing('nav-user-list') }" v-if="checkPermission('CreateUser')">
        <a href="javascript:void(0);" id="nav-users"
        @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#nav-user-list"
        :class="{ 'nav-dropdown-toggle': true, 'nav-link': true, 'nav-item-collapse': true, 'active': is_showing('nav-user-list') }"><i class="mr-2 fas fa-headset"></i><span>Users</span></a>
        <ul id="nav-user-list" :class="{ 'collapse': true, 'show': is_showing('nav-user-list') }" data-target="#nav-users">
          <li :class="{ 'nav-item': true, 'active': isActive('manage-users') }">
            <router-link :to="{ name: 'manage-users' }" class="nav-link" :class="{ 'router-link-exact-active router-link-active': setTabActive('users') }"><span>Manage Users</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('adduser') }">
            <router-link :to="{ name: 'adduser' }" class="nav-link"><span>Add New User</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('users/import-users') }">
            <router-link :to="{ name: 'users/import-users' }" class="nav-link"><span>Import Users</span></router-link>
          </li>
        </ul>
      </li>
      <li :class="{ 'nav-item nav-dropdown': true, 'open': is_showing('nav-agencies-list') }"  v-if="checkPermission('CreateAgency')">
        <a id="nav-agencies" href="javascript:void(0);"
        @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#nav-agencies-list"
        :class="{ 'nav-dropdown-toggle': true, 'nav-link': true, 'nav-item-collapse': true, 'active': is_showing('nav-agencies-list') }"><i class="mr-2 fas fa-globe"></i><span>Agencies</span></a>
        <ul id="nav-agencies-list" :class="{ 'collapse': true, 'show': is_showing('nav-agencies-list') }" data-target="#nav-agencies">
          <li :class="{ 'nav-item': true, 'active': isActive('agencymanager') }">
            <router-link :to="{ name: 'agencymanager' }" class="nav-link" :class="{ 'router-link-exact-active router-link-active': setTabActive('agencies') }"><span>Agency Manager</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('addagency') }">
            <router-link :to="{ name: 'addagency' }" class="nav-link"><span>+Add Agency</span></router-link>
          </li>
        </ul>
      </li>
      <li :class="{ 'nav-item nav-dropdown': true, 'open': is_showing('nav-agencies-list') }"  v-else-if="checkPermission('GetAgencyAppointedCarriers')">
        <a href="javascript:void(0);" id="nav-carriers-appointed"
        @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#nav-agencies-list"
        :class="{ 'nav-dropdown-toggle': true, 'nav-link': true, 'nav-item-collapse': true, 'active': is_showing('nav-agencies-list') }"><i class="mr-2 fas fa-globe"></i><span>Agency</span></a>
        <ul id="nav-agencies-list" :class="{ 'collapse': true, 'show': is_showing('nav-agencies-list') }" data-target="#nav-carriers-appointed">
          <li :class="{ 'nav-item': true, 'active': isActive('agencymanager') && !$store.getters.getACStatus }">
            <router-link :to="{ name: 'agency-details', query: {agencyID: getAgencyID(), showTab:'am'} }" :class="{ 'nav-item': true, 'active': isActive('agencymanager') && !$store.getters.getACStatus, 'inactive-link': $store.getters.getACStatus }" class="nav-link" @click.native="checkTabStatusNav(false)"><span>Agency Details</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('addagency') || $store.getters.getACStatus }">
            <router-link :to="{ name: 'editagency', query: {agencyID: getAgencyID(), showTab:'ap'} }" class="nav-link"
            :class="{ 'router-link-exact-active router-link-active': setTabActive('ap') }" @click.native="checkTabStatusNav(true)"><span>Appointed Carriers</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('carrierlogin') || $store.getters.getACStatus }">
            <router-link :to="{ name: 'editagency', query: {agencyID: getAgencyID(), showTab:'cl'} }" class="nav-link"
            :class="{ 'router-link-exact-active router-link-active': setTabActive('cl') }" @click.native="checkTabStatusNav(false)"><span>Carrier Logins</span></router-link>
          </li>
        </ul>
      </li>
      <li :class="{ 'nav-item nav-dropdown': true, 'open': is_showing('nav-carriers-list') }" v-if="checkPermission('GetAllCarriers')">
        <a href="javascript:void(0);" id="nav-carriers-manager"
        @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#nav-carriers-list"
        :class="{ 'nav-dropdown-toggle': true, 'nav-link': true, 'nav-item-collapse': true, 'active': is_showing('nav-carriers-list') }"><i class="mr-2 fas fa-umbrella"></i><span>Carriers</span></a>
        <ul id="nav-carriers-list" :class="{ 'collapse': true, 'show': is_showing('nav-carriers-list') }" data-target="#nav-carriers-manager">
          <li :class="{ 'nav-item': true, 'active': isActive('carriers/carrier-manager') }">
            <router-link :to="{ name: 'carrier-manager' }" class="nav-link" :class="{ 'router-link-exact-active router-link-active': setTabActive('carriers') }"><span>Carrier Manager</span></router-link>
          </li>          
          <!-- <li :class="{ 'nav-item': true, 'active': isActive('carriers/add-carrier') }">
            <router-link :to="{ name: 'carriers/add-carrier' }" class="nav-link"><span>+Add Carrier</span></router-link>
          </li>         -->
        </ul>
      </li>
      <li :class="{ 'nav-item nav-dropdown': true, 'open': is_showing('nav-reports-list') }">
        <a href="javascript:void(0);" id="nav-reports"
        @keydown.enter.prevent.stop="toggle_collapse"
        @click.prevent="toggle_collapse"
        data-target="#nav-reports-list"
        :class="{ 'nav-dropdown-toggle': true, 'nav-link': true, 'nav-item-collapse': true, 'active': is_showing('nav-reports-list') }"><i class="mr-2 fas fa-chart-pie"></i><span>Reports</span></a>
        <ul id="nav-reports-list" :class="{ 'collapse': true, 'show': is_showing('nav-reports-list') }" data-target="#nav-reports">
          <li :class="{ 'nav-item': true, 'active': isActive('reports/carriers') }">
            <router-link :to="{ name: 'reports/carriers' }" class="nav-link"><span>Carriers</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('reports/states') }">
            <router-link :to="{ name: 'reports/states' }" class="nav-link"><span>States</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('reports/agents') }">
            <router-link :to="{ name: 'reports/agents' }" class="nav-link"><span>Agents</span></router-link>
          </li>
          <li :class="{ 'nav-item': true, 'active': isActive('reports/products') }">
            <router-link :to="{ name: 'reports/products' }" class="nav-link"><span>Products</span></router-link>
          </li>
          <li class="disabled" :class="{ 'nav-item': true, 'active': isActive('#') }">
            <router-link :to="'#'" class="nav-link"><span>Teams</span></router-link>
          </li>
        </ul>
      </li>
      <li v-if="hasPermissionsToDisplay(dailyActivityReportPermissions)" class="nav-item">
        <a href="javascript:void(0);" class="nav-link daily-activity-report"><i class="mr-2 fas fa-file-download"></i><span>Daily Activity Report</span></a>
      </li>
      <li  class="nav-item">
         <router-link :to="{ name: 'your-profile', query: {userID: getUserID()} }" class="nav-link"> <i class="mr-2  fas fa-user-circle"></i><span>Your Profile</span></router-link>
      </li>
      <li class="nav-item disabled">
        <router-link :to="'#'" class="nav-link"><span>Tools</span></router-link>
      </li>
      <li  class="nav-item">
         <router-link :to="{ name: 'training/videos' }" class="nav-link"> <i class="mr-2 fas fa-sharp fa-regular fa-graduation-cap"></i><span>Training Videos</span></router-link>
      </li>
    </ul>
  </nav>
  <button @click="toggleNav('admin-sidebar')" aria-label="minimize-sidebar" class="sidebar-minimizer brand-minimizer" type="button"></button>
</div>
</template>

<script>
// TODO: Use config values
// eslint-disable-next-line no-unused-vars
import common from '../../../services/common';

export default {
  data() {
    return {
      dailyActivityReportPermissions: [ // TODO: Use config values
        'DownloadAllAgenciesDailyActivityReport',
        'DownloadAgencyDailyActivityReport',
        'DownloadAgentDailyActivityReport',
      ],
      collapsed_elements: [], // List of elements marked as not showing (collapsed)
    };
  },
  computed: {
    adminNavCollapsed: {
      get() {
        return !!(this.$store.state.adminNavCollapsed);
      },
      set(value) {
        this.$store.state.adminNavCollapsed = value;
      },
    },
  },
  methods: {
    setTabActive(tabName) {
      console.log('route', this.$route.name, this.$route.query.showTab);
      if (tabName === 'agencies' && (this.$route.name === 'editagency')) {
        return true;
      }
      if (tabName === 'users' && (this.$route.name === 'edit-user')) {
        return true;
      }
      if (tabName === 'carriers' && (this.$route.name === 'carriers/edit-carrier')) {
        return true;
      }
      if (tabName === 'ap' && this.$route.query && this.$route.query.showTab === 'ap') {
        return true;
      }
      if (tabName === 'cl' && this.$route.query && this.$route.query.showTab === 'cl') {
        return true;
      }
      return false;
    },
    checkTabStatusNav(ac) {
      this.$store.dispatch('setAppointedCarrierStatus', ac);
    },
    hasPermissionsToDisplay(permissions) {
      // TODO: Get the User's permissions list from a helper class
      const userPermissions = (sessionStorage.getItem('permissions') ? sessionStorage.getItem('permissions').split(',') : []);
      const intersectingPermissions = userPermissions.filter(x => permissions.includes(x));

      // If _any_ of these permissions exist in the User permissions, then allow the link to show
      return (intersectingPermissions.length);
    },
    /**
     * Returns whether the given ID is in the list of collapsed elements.
     */
    is_showing(elId) {
      return (this.collapsed_elements.indexOf(elId) === -1);
    },
    isActive(routeName) {
      return (routeName === this.$route.name);
    },
    /**
     * Fetches the list of collapsed elements from the session.
     */
    get_collapsed_elements_list() {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value

      return JSON.parse(sessionStorage.getItem(TOGGLE_COLLAPSE)) || []; // List of elements marked as showing
    },
    /**
     * Show/hide elements and store their state in the session.
     *
     * @param {element or string} event - The source that triggered this
     * @param {boolean} fromCollapser - Whether the collapser element triggered this (flips target and source)
     */
    toggle_collapse(event, fromCollapser = false) {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value
      const targetName = (fromCollapser ? event.id : event.currentTarget.dataset.target.substring(1)); // Name of target w/o the '#'
      const sourceName = (fromCollapser ? event.dataset.target.substring(1) : event.currentTarget.id); // ID of element that triggered this
      const i = this.collapsed_elements.indexOf(targetName); // Index of current target, if it exists in the list

      if (i === -1) {
        document.getElementById(targetName).classList.remove('show'); // Toggle whether it shows
        document.getElementById(sourceName).classList.remove('active'); // Toggle +/-
        this.collapsed_elements.push(targetName); // Add to list of showing elements
      } else {
        document.getElementById(targetName).classList.add('show'); // Toggle whether it shows
        document.getElementById(sourceName).classList.add('active'); // Toggle +/-
        this.collapsed_elements.splice(i, 1); // Remove from list of showing elements
      }

      sessionStorage.setItem(TOGGLE_COLLAPSE, JSON.stringify(this.collapsed_elements)); // Set new list back into session
    },
    /**
     * Toggles sidebar. Core UI does this by changing the `body` classes.
     */
    toggleNav(targetName, alwaysExpand) {
      const mainContent = document.getElementById('main-content');
      const collapsableEls = document.getElementById('admin-sidebar').getElementsByClassName('collapse show');

      // TODO: Use less LOC
      if (this.$refs[targetName].classList.contains('sidebar-open') && !alwaysExpand) {
        this.$refs[targetName].classList.remove('sidebar-open');
        this.$refs[targetName].classList.add('sidebar-close');
        mainContent.classList.add('collapsed-sidebar');
        this.adminNavCollapsed = true;
        Array.prototype.forEach.call(collapsableEls, (el) => {
          el.classList.add('collapse-temporary'); // Temporarily hide nested lists
        });
      } else {
        this.$refs[targetName].classList.add('sidebar-open');
        this.$refs[targetName].classList.remove('sidebar-close');
        mainContent.classList.remove('collapsed-sidebar');
        this.adminNavCollapsed = false;
        Array.prototype.forEach.call(collapsableEls, (el) => {
          el.classList.remove('collapse-temporary'); // Unhided temporarily hidden nested lists
        });
      }
    },
    checkPermission(permissionName) {
      return common.checkPermission(permissionName);
    },
    getAgencyID() {
      return sessionStorage.getItem('agencyId');
    },
    getUserID() {
      return sessionStorage.getItem('userId');
    },
  },
  created() {
    this.collapsed_elements = this.get_collapsed_elements_list(); // TODO: Only fetch this once
  },
  mounted() {
    if (this.adminNavCollapsed) {
      this.toggleNav('admin-sidebar');
    }
  },
};
</script>
<style scoped>
/* Navigation Toggle CSS */
html:not([dir="rtl"]) .sidebar.sidebar-open {
  overflow: hidden;
  transition: width .2s ease-in-out;
  margin-left: 0; /* TODO: Use Bootstrap JS */
  left: 0;
}
  html:not([dir="rtl"]) .sidebar.sidebar-close{
    transition: width .2s ease-in-out;
    width: 50px;
    margin-left: 0; /* TODO: Use Bootstrap JS */
    left: 0;
  }
  .sidebar.sidebar-close .sidebar-minimizer::before {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }

/* COLLAPSED NAVIGATION CSS */
.sidebar.sidebar-close .sidebar-nav,
.sidebar.sidebar-close .nav {
  width: 50px;
}
  .sidebar.sidebar-close .sidebar-nav:hover,
  .sidebar.sidebar-close .nav:hover {
    overflow: visible;
  }
    .sidebar.sidebar-close .nav-item {
      position: relative;
      width: 50px;
      height: 45px;
    }
  /* Hide/Show Sub-menus onHover CSS */
  .sidebar.sidebar-close .nav-item:hover .nav-link {
    position: absolute;
    width: 200px;
  }
  /* Sub-menus Icon CSS */
  .sidebar.sidebar-close .nav-link i{
    margin: 0 1.125rem 0 0;
  }
    .sidebar.sidebar-close .nav-item:hover .nav-link i{
      color: #FFFFFF;
      fill: currentColor;
    }

  /* Hide/Show Menu Item Label onHover CSS */
  .sidebar.sidebar-close .nav-item span {
    display: none;
  }
    .sidebar.sidebar-close .nav-item:hover span {
      display: inline-block;
      position: relative;
      visibility: visible;
      opacity: 1;
    }

  /* Collapsed Sub-menu CSS */
  .sidebar.sidebar-close .nav-item:hover .nav-dropdown-toggle {
    background: #003366;
  }
    /* Hide Sub-menu Carot */
    .sidebar.sidebar-close .nav-dropdown-toggle::before {
      display: none;
    }
    .sidebar.sidebar-close .nav-item:hover ul {
      display: block;
      position: absolute;
      z-index: 1000;
      width: 150px;
      margin: 45px 0 0 50px;
      background: #3674B2;
      overflow: hidden;
    }
      .sidebar.sidebar-close .collapse .nav-item{
        width: 150px;
        display: block;
        background: rgba(0, 0, 0, 0.2);
      }
        .sidebar.sidebar-close .collapse .nav-item .nav-link:hover{
          background: #003366;
          -webkit-box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.35) !important;
          box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0.35) !important;
        }
    /* Sub-menu Remove Expanded Dropdown Styling */
    .sidebar.sidebar-close .nav-dropdown.open .nav-dropdown-toggle {
      -webkit-box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0) !important;
      box-shadow: 0 0.125rem 0.375rem rgba(0, 0, 0, 0) !important;
    }

.collapse-temporary {
  display: none;
}

.nav-item {
  cursor: pointer;
}

.nav-link.active,
.nav-item.active {
  background: #000A13;
}

.nav-item-collapse,
.nav-item-collapse.active {
  cursor: pointer;
  background: #00162B;
}

.nav-item ul {
  padding-left: 0;
}

.nav-item ul > li{
  list-style: none;
}

.sidebar.sidebar-open .nav-item ul.collapse > li a{
  padding-left: 2.625rem;
}

.sidebar {
  height: calc(100vh - 48px) !important;
  background: #3674B2;
}

  .sidebar .nav-link .nav-icon {
    color: #FFFFFF;
  }
    .sidebar .nav-link.router-link-exact-active .nav-icon {
      color: #FFFFFF;
    }
    .sidebar .nav-link.router-link-exact-active .nav-icon:focus {
      color: #FFFFFF !important;
    }
    .sidebar .nav-dropdown > .nav-link:hover .nav-icon{
      color: #FFFFFF;
      fill: currentColor;
    }

  .sidebar .nav-dropdown-toggle::before{
    margin-right: 4px;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='rgb(255, 255, 255)' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E");
  }

.sidebar .nav-dropdown.open .nav-dropdown-toggle {
  background-color: #00162B;
  color: #fff;
}

.sidebar .nav-item .nav-link.router-link-exact-active {
    background-color: #E5EAEF;
    color: #00162B;
}
.sidebar .nav-link:hover, .sidebar .nav-link:focus, .sidebar .nav-link:focus-visible,
.sidebar .nav-dropdown.open .nav-dropdown-toggle:hover, .sidebar .nav-dropdown.open .nav-dropdown-toggle:focus{
  background-color: #2E4152;
  color: #FFF;
  outline: none !important;

}

.nav-link.router-link-exact-active .nav-icon {
  color: #00162B !important;
}
#nav-agencies-list .inactive-link{
  background-color: transparent !important;
}
.sidebar .sidebar-minimizer:focus {
  background: #2E4152;
  color: #ffffff;
}
.sidebar .nav-item .nav-link.router-link-exact-active:focus{
  background: #2E4152;
  color: #ffffff;
}
.sidebar .sidebar-minimizer::before {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23ffffff' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E") !important;
}
  /**DAILY ACTIVITY REPORT MENU ITEM CSS**/
.sidebar .nav-link.daily-activity-report{
  background: #2E7B32;
}
  .sidebar.sidebar-close .nav-link.daily-activity-report:hover  {
  }
    .sidebar .nav-link.daily-activity-report:hover, .sidebar .nav-link.daily-activity-report:focus {
      background: #2E4152;
      color: #ffffff;
    }
    .sidebar .nav-link.daily-activity-report .nav-icon {
      color: #FFFFFF;
    }
    /**HIDE DISABLED MENU ITEM CSS**/
    .sidebar .nav-item.disabled{
      display: none !important;
    }

  /**MINIMIZED SIDEBAR CoreUI Override CSS**/
  .sidebar .sidebar-minimizer{
    display: block;
    background: #000A13;
    color: #ffffff;
  }
.sidebar {
  background: #00162B !important;
  color: #ffffff;
}
</style>
<style>
#main-content.collapsed-sidebar {
  margin-left: 50px; /* Added to main content section when the sidebar is collapsed */
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/Navigation.vue?195855c7